var _rect, _rect2, _rect3, _path, _g, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSr(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "sr",
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_34",
    "data-name": "Rectangle 34",
    width: 512,
    height: 512,
    fill: "#0052b4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_35",
    "data-name": "Rectangle 35",
    width: 512,
    height: 170.663,
    fill: "#d80027"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_36",
    "data-name": "Rectangle 36",
    width: 512,
    height: 170.663,
    transform: "translate(0 341.337)",
    fill: "#f0f0f0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M101.787,155.826V278.212c0,69.616,90.947,90.948,90.947,90.948s90.947-21.331,90.947-90.948V155.826Z",
    fill: "#d80027"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10",
    "data-name": "Group 10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M139.4,177.16H246.067V134.493L224.733,145.16l-32-32-32,32L139.4,134.493Z",
    fill: "#ffda44"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M262.348,295.251l-69.334-69.333-69.333,69.333,22.627,22.628,46.706-46.707,46.707,46.707Z",
    fill: "#ffda44"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M262.348,230.493H230a21.325,21.325,0,1,0-37.264-20.734,21.325,21.325,0,1,0-37.264,20.734H123.68c0,11.783,10.262,21.334,22.044,21.334h-.71a21.333,21.333,0,0,0,21.334,21.334,21.329,21.329,0,0,0,17.387,20.954l-16.809,37.953a69.372,69.372,0,0,0,52.18,0L202.3,294.115a21.33,21.33,0,0,0,17.387-20.954,21.333,21.333,0,0,0,21.334-21.334h-.71C252.085,251.826,262.348,242.275,262.348,230.493Z",
    fill: "#f0f0f0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSr);
export default __webpack_public_path__ + "static/media/sr.e6a41960c703a4165b158c0da1ec7b27.svg";
export { ForwardRef as ReactComponent };